var E = /* @__PURE__ */ ((e) => (e.HEXCODE = "hex-code", e.THEME = "theme", e))(E || {});
export {
  E as cmsColorOptionType
};
//# sourceMappingURL=enum.js.map
